<script setup lang="ts">
defineProps<{
  compact?: boolean
}>()
</script>
<template>
  <a
    :href="
      createHotlineLink({
        text: 'Halo, saya tertarik dengan fitur KiriminAja'
      })
    "
    target="_blank"
    aria-label="Whatsapp Support"
    :class="
      cn(
        'fixed z-95 text-white items-center bg-linear-to-b from-[#25d366] to-[#16a34b] shadow-xl p-2.5 group gap-2 flex rounded-full transition-all transform bottom-6 right-5',
        {
          'pr-5': !compact,
          'p-1.5 border-none': compact
        }
      )
    "
  >
    <span
      :class="
        cn('absolute top-0 right-0 flex size-4 text-red-500', {
          'translate-y-0 translate-x-0 scale-70': compact
        })
      "
    >
      <span
        class="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-75"
      ></span>
      <span class="relative inline-flex size-4 rounded-full bg-current"></span
    ></span>

    <Icon
      name="ic:outline-whatsapp"
      size="32px"
      class="group-hover:rotate-5 transition-all"
    />
    <span v-if="!compact" class="grow grid">
      <span class="font-medium text-xs">Hubungi Kami</span>
      <span class="font-bold text-sm">via WhatsApp</span>
    </span>
  </a>
</template>
